const state = {
  list: [],
  showNoti: undefined, //新消息提醒是否弹出通知
  audioPlay: undefined, //声音提醒
  hasNew: true, //是否有新消息
  hasMsg: true, //是否有未读消息
  showMsgCenter: false, //是否打开消息中心
  hasLoad: false, //是否调接口加载数据
  currentIndex: -1
};

const mutations = {
  set(state, obj) {
    for (var key in obj) {
      state[key] = obj[key];
    }
  },
  setData(state, data) {
    state.list = data;
  },
  setShowNoti(state, showNoti) {
    state.showNoti = showNoti;
    localStorage.setItem("showNoti", showNoti ? 1 : 0);
  },
  setAudioPlay(state, audioPlay) {
    state.audioPlay = audioPlay;
    localStorage.setItem("audioPlay", audioPlay ? 1 : 0);
  },
  setHasNew(state, has) {
    state.hasNew = has;
  },
  checkHasMsg(state) {
    state.hasMsg = state.list.Any(x => !x.ck);
  },
  setShowMsgCenter(state, show) {
    state.showMsgCenter = show;
  },
  setHasLoad(state) {
    state.hasLoad = true;
  },
  select(state, index) {
    state.currentIndex = index;
    state.list[index].ck = true;
    state.hasMsg = state.list.Any(x => !x.ck);
  },
  del(state) {
    state.list.splice(state.currentIndex, 1);
    state.currentIndex = -1;
    state.hasMsg = state.list.Any(x => !x.ck);
  },
  delRead(state) {
    state.list.Each((x, index) => {
      if (x.ck && index == state.currentIndex) {
        state.currentIndex = -1;
      }
    });
    state.list.Delete(x => x.ck);
  },
  readAll(state) {
    state.list.Each(x => (x.ck = true));
    state.hasMsg = state.list.Any(x => !x.ck);
  },
  push(state, msg) {
    if (state.hasLoad) {
      state.list.unshift(msg);
    }
    if (!state.showMsgCenter) {
      state.hasNew = true;
    }
    state.hasMsg = true;
    if (state.currentIndex > -1) {
      state.currentIndex += 1;
    }
  }
};

const actions = {
  setDataAsync(context, data) {
    context.commit("setData", data);
  },
  //模拟调接口，查询消息
  getMsg(context) {
    context.commit("setData", getList());
  },
  //设置是否显示消息中心
  setShowMsgCenter(context, show) {
    context.commit("setShowMsgCenter", show);
    if (show && !context.state.hasLoad) {
      context.commit("setHasLoad");
      //如果当前未调接口，则请求一次
      context.commit("setData", getList());
      context.commit("checkHasMsg");
    }
  },
  //推送新消息
  push(context, msg) {
    context.commit("push", msg);
  }
};

const getters = {
  showNoti(state) {
    if (state.showNoti == undefined) {
      let showNoti = localStorage.getItem("showNoti");
      if (showNoti == null || showNoti == undefined) {
        localStorage.setItem("showNoti", 0);
        showNoti = "0";
      }
      state.showNoti = showNoti == "1";
    }
    return state.showNoti;
  },
  audioPlay(state) {
    if (state.audioPlay == undefined) {
      let audioPlay = localStorage.getItem("audioPlay");
      if (audioPlay == null || audioPlay == undefined) {
        localStorage.setItem("audioPlay", 0);
        audioPlay = "0";
      }
      state.audioPlay = audioPlay == "1";
    }
    return state.audioPlay;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};

function getList() {
  var list = [];
  for (var i = 0; i < 20; i++) {
    list.push({
      id: i,
      ck: false,
      title: `新消息提醒${i}新消息提醒`,
      msg: `订单编号：2103180002
需求日期：2021/3/19 0:00:00
销售员：吴紫娟
收货人：Sophia-13774473541
收货地址：上海上海市徐汇区闵虹路166弄中庚环球创意中心3号楼27楼`
    });
  }
  return list;
}